import { render, staticRenderFns } from "./RecuperatorCard.vue?vue&type=template&id=5b28d64c"
import script from "./RecuperatorCard.vue?vue&type=script&lang=js"
export * from "./RecuperatorCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports